import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import { Container } from 'reactstrap'
import { connect } from 'react-redux'
import * as loadingActions from '../../../state/actions/loading'

import Config from '../../../config/Config.json'
import Config_local from '../../../config/Config_local.json'

import BonsPlansJeunesForm from "./../Form/BonsPlansJeunesForm"
import BonsPlansJeunesFilterReset from './../Form/BonsPlansJeunesFilterReset';

import BonsPlansJeunesBreadcrumb from './../BonsPlansJeunesBreadcrumb'
import BonsPlansJeunesListItem from './BonsPlansJeunesListItem'

import Pagination from "../../Pagination/Pagination"

const config = { ...Config, ...Config_local }

class BonsPlansJeunesList extends Component {
	_isMounted = false

	constructor(props, context) {
		super(props, context)
		
		// Validation des props
		if (!props.loadingOn || !props.loadingOff) {
			console.warn('BonsPlansJeunesList: Props loadingOn et loadingOff requises')
		}
		
		this.state = {
			mysearch: '',
			bonsPLansJeunesFilterFilterActiveThemes: '',
			bonsPLansJeunesFilterFilterActivePublics: '',
			posts: 0,
			page: this.getStoredPage(),
			error: null,
			isLoading: false,
			hasSearched: false
		}
	}

	// Méthode sécurisée pour récupérer la page depuis localStorage
	getStoredPage = () => {
		try {
			const storedPage = localStorage.getItem('BonsPlanJeunesFilterPage')
			return storedPage ? parseInt(storedPage, 10) || 0 : 0
		} catch (error) {
			console.warn('Impossible de récupérer la page depuis localStorage:', error)
			return 0
		}
	}

	// Méthode sécurisée pour sauvegarder dans localStorage
	setStoredItem = (key, value) => {
		try {
			localStorage.setItem(key, value)
		} catch (error) {
			console.warn(`Impossible de sauvegarder ${key} dans localStorage:`, error)
		}
	}

	// Méthode sécurisée pour récupérer depuis localStorage
	getStoredItem = (key, defaultValue = '') => {
		try {
			return localStorage.getItem(key) || defaultValue
		} catch (error) {
			console.warn(`Impossible de récupérer ${key} depuis localStorage:`, error)
			return defaultValue
		}
	}

	componentDidMount() {
		this._isMounted = true
		const { loadingOn } = this.props
		
		if (loadingOn) {
			loadingOn('BonsPlansJeunesList')
		}
		
		this.setState({
			mysearch: this.getStoredItem('BonsPLansJeunesFilterMySearch'),
			bonsPLansJeunesFilterFilterActiveThemes: this.getStoredItem('BonsPLansJeunesFilterFilterActiveThemes'),
			bonsPLansJeunesFilterFilterActivePublics: this.getStoredItem('BonsPLansJeunesFilterFilterActivePublics'),
			bonsPlansJeunesResetShow: this.getStoredItem('BonsPLansJeunesFilterMySearch') ||
				this.getStoredItem('BonsPLansJeunesFilterFilterActiveThemes') ||
				this.getStoredItem('BonsPLansJeunesFilterFilterActivePublics') ||
				false,
		}, () => {
			this.launchSearch()
		})
	}

	componentWillUnmount() {
		const { loadingOff } = this.props
		this._isMounted = false
		if (loadingOff) {
			loadingOff('BonsPlansJeunesList')
		}
	}

	launchSearch = () => {
		if (!this._isMounted) return;

		this.setState({ isLoading: true, error: null, hasSearched: true });
		
		const page = Math.max(0, ((this.state.page - 1) >= 0 ? ((this.state.page - 1) * 12) : 0))
		let queryOpenData = "?where=";
		let where = "1=1";
		
		// Validation et nettoyage des paramètres de recherche
		if (this.state.mysearch && this.state.mysearch.trim().length > 0) {
			const cleanSearch = this.state.mysearch.trim()
			where = where + ' AND ( LOWER(nom_dispositif) LIKE LOWER(\'%25' + encodeURI(cleanSearch) + '%25\') )';
		}
		if (this.state.bonsPLansJeunesFilterFilterActiveThemes && this.state.bonsPLansJeunesFilterFilterActiveThemes.trim().length > 0) {
			const cleanTheme = this.state.bonsPLansJeunesFilterFilterActiveThemes.trim()
			where = where + ' AND LOWER(thematique)=LOWER(\'' + encodeURI(cleanTheme) + '\')';
		}
		if (this.state.bonsPLansJeunesFilterFilterActivePublics && this.state.bonsPLansJeunesFilterFilterActivePublics.trim().length > 0) {
			const cleanPublic = this.state.bonsPLansJeunesFilterFilterActivePublics.trim()
			where = where + ' AND tranche_d_age=\'' + encodeURI(cleanPublic) + '\'';
		}

		queryOpenData = queryOpenData + where + '&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields="*"&returnGeometry=true&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&gdbVersion=&historicMoment=&returnDistinctValues=false&returnIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&multipatchOption=xyFootprint&resultOffset=&resultRecordCount=&returnTrueCurves=false&returnExceededLimitFeatures=false&quantizationParameters=&returnCentroid=false&timeReferenceUnknownClient=false&sqlFormat=none&resultType=&featureEncoding=esriDefault&datumTransformation=';
		
		fetch(
			"https://carto.ville-roubaix.fr/server/rest/services/OpenData/SOLIDARITE/FeatureServer/32/query" + queryOpenData + "&f=json",
			{
				headers: {},
				method: "GET",
			}
		)
			.then((response) => {
				if (!this._isMounted) return;
				
				if (response.status && response.status > 200) {
					throw new Error(`Erreur HTTP: ${response.status}`);
				} else {
					return response.json();
				}
			})
			.then((results) => {
				if (!this._isMounted) return;
				
				// Validation des résultats
				if (!results || typeof results !== 'object') {
					throw new Error('Format de réponse invalide');
				}
				
				const { nhits, offset, limit, features } = results;
				const { loadingOff } = this.props;

				// Validation des données reçues
				const validFeatures = Array.isArray(features) ? features : [];
				const validNhits = typeof nhits === 'number' ? nhits : 0;

				this.setState({
					totals: validNhits,
					offset: offset || 0,
					limit: limit || 12,
					page: this.getStoredPage(),
					posts: validFeatures,
					isLoading: false,
					error: null
				});
				this.bonsPlansJeunesOnPaginateScroll();
				if (loadingOff) {
					loadingOff("BonsPlansJeunesList")
				}
			})
			.catch((error) => {
				if (!this._isMounted) return;
				
				console.warn("Erreur lors de la recherche:", error);
				const errorMessage = error.message || "Une erreur est survenue lors de la recherche. Veuillez réessayer.";
				
				this.setState({ 
					error: errorMessage,
					isLoading: false,
					posts: [],
					totals: 0
				});
				const { loadingOff } = this.props;
				if (loadingOff) {
					loadingOff("BonsPlansJeunesList")
				}
			});
	}

	bonsPlansJeunesOnKeyDown = ({ target, key }) => {
		// Gestion accessible des événements clavier
		if (key === 'Enter') {
			this.launchSearch()
		} else if (key === 'Escape') {
			// Réinitialiser la recherche avec Escape
			this.bonsPlansJeunesOnReset({ preventDefault: () => {} })
		}
	}

	bonsPlansJeunesOnKeyUp = ({ key, target }) => {
		// Gestion de la recherche en temps réel avec validation
		const { value } = target
		const cleanValue = value ? value.trim() : ''
		
		// Éviter les recherches trop fréquentes
		if (this.searchTimeout) {
			clearTimeout(this.searchTimeout)
		}
		
		this.searchTimeout = setTimeout(() => {
			this.setState({
				mysearch: cleanValue
			}, () => {
				this.setStoredItem('BonsPLansJeunesFilterMySearch', cleanValue)
				this.launchSearch()
			})
		}, 300) // Délai de 300ms pour éviter les appels API trop fréquents
	}

	bonsPlansJeunesOnChangeFilterThemes = (val) => {
		// Validation de la valeur du thème
		const cleanVal = val && typeof val === 'string' ? val.trim() : ''
		
		this.setState({
			bonsPLansJeunesFilterFilterActiveThemes: cleanVal,
			bonsPlansJeunesResetShow: true,
			page: 0
		}, () => {
			this.setStoredItem('BonsPLansJeunesFilterFilterActiveThemes', cleanVal);
			this.setStoredItem('BonsPLansJeunesFilterPage', 0);
			this.setStoredItem('BonsPlansJeunesFilterResetShow', true);
			this.launchSearch()
		})
	}

	bonsPlansJeunesOnChangeFilterPublics = (val) => {
		// Validation de la valeur du public
		const cleanVal = val && typeof val === 'string' ? val.trim() : ''
		
		this.setState({
			bonsPLansJeunesFilterFilterActivePublics: cleanVal,
			bonsPlansJeunesResetShow: true,
			page: 0
		}, () => {
			this.setStoredItem('BonsPLansJeunesFilterFilterActivePublics', cleanVal);
			this.setStoredItem('BonsPLansJeunesFilterPage', 0);
			this.setStoredItem('BonsPlansJeunesFilterResetShow', true);
			this.launchSearch()
		})
	}

	bonsPlansJeunesOnSubmit = (e) => {
		if (e) {
			e.preventDefault()
		}
		this.launchSearch()
	}

	bonsPlansJeunesOnClickPaginate = (e) => {
		if (e) {
			e.preventDefault()
		}
		
		const pageNum = e.target.getAttribute('data-num-page')
		const validPage = parseInt(pageNum, 10)
		
		if (!isNaN(validPage) && validPage >= 0) {
			this.setState({
				page: validPage
			}, () => {
				this.setStoredItem('BonsPlansJeunesFilterPage', validPage);
				this.bonsPlansJeunesOnPaginateScroll()
				this.launchSearch()
			})
		}
	}

	bonsPlansJeunesOnPaginateScroll = () => {
		if (typeof window !== 'undefined') {
			const filtersElement = document.querySelector(".bons-plans-jeunes-filters");
			if (filtersElement) {
				// Scroll accessible avec focus sur les filtres
				filtersElement.focus()
				window.scrollTo({
					top: filtersElement.getBoundingClientRect().top - 100,
					behavior: 'smooth'
				})
			}
		}
	}

	bonsPlansJeunesOnReset = (e) => {
		if (e) {
			e.preventDefault()
		}
		
		this.setState({
			mysearch: '',
			bonsPLansJeunesFilterFilterActiveThemes: '',
			bonsPLansJeunesFilterFilterActivePublics: '',
			page: 0,
			bonsPlansJeunesResetShow: false,
			error: null
		}, () => {
			// Nettoyage du localStorage
			this.setStoredItem('BonsPLansJeunesFilterMySearch', '')
			this.setStoredItem('BonsPLansJeunesFilterFilterActiveThemes', '');
			this.setStoredItem('BonsPLansJeunesFilterFilterActivePublics', '');
			this.setStoredItem('BonsPLansJeunesFilterPage', 0);
			this.setStoredItem('BonsPlansJeunesFilterResetShow', false);
			this.launchSearch()
		})
	}

	render() {
		const { posts, totals, page, error, isLoading, hasSearched } = this.state
		const hasResults = posts && Array.isArray(posts) && posts.length > 0;
		const searchQuery = this.state.mysearch ? this.state.mysearch.trim() : '';
		const totalResults = totals || 0;
		
		// Validation des props
		if (!this.props.loadingOn || !this.props.loadingOff) {
			return (
				<div 
					className="bons-plans-jeunes-error" 
					role="alert" 
					aria-live="polite"
					aria-describedby="bons-plans-jeunes-error-description"
				>
					<div id="bons-plans-jeunes-error-description" className="visually-hidden">
						Erreur de configuration du composant BonsPlansJeunesList
					</div>
					<p>Erreur de configuration. Veuillez contacter l'administrateur.</p>
				</div>
			)
		}
		
		return (
			<div>
				<Container>
					<Helmet>
						<title>Ville de Roubaix : Bons plans jeunes</title>
						<meta name="description" content="Découvrez et recherchez les bons plans jeunes disponibles à Roubaix. Filtrez par thème et tranche d'âge." />
					</Helmet>
					<div className="offline-fallback-fix-no-idea-why" aria-hidden="true"></div>
					<BonsPlansJeunesBreadcrumb />
					<main 
						id="bons-plans-jeunes" 
						className="bons-plans-jeunes"
						role="main"
						aria-label="Liste des bons plans jeunes"
						aria-describedby="bons-plans-jeunes-description"
					>
						<div id="bons-plans-jeunes-description" className="visually-hidden">
							Page de recherche et d'affichage des bons plans jeunes avec filtres et pagination
						</div>
						
						<BonsPlansJeunesForm
							bonsPLansJeunesFilterMySearch={this.state.mysearch}
							bonsPLansJeunesFilterFilterActiveThemes={this.state.bonsPLansJeunesFilterFilterActiveThemes}
							OnChangeFilterThemes={this.bonsPlansJeunesOnChangeFilterThemes}
							bonsPLansJeunesFilterFilterActivePublics={this.state.bonsPLansJeunesFilterFilterActivePublics}
							OnChangeFilterPublics={this.bonsPlansJeunesOnChangeFilterPublics}
							onSubmit={this.bonsPlansJeunesOnSubmit}
							placeholder="Chercher un bon plan"
							type="text"
							onKeyDown={this.bonsPlansJeunesOnKeyDown}
							onKeyUp={this.bonsPlansJeunesOnKeyUp}
						/>

						{error && (
							<div 
								className="alert alert-danger" 
								role="alert" 
								aria-live="polite"
								aria-describedby="bons-plans-jeunes-error-description"
							>
								<div id="bons-plans-jeunes-error-description" className="visually-hidden">
									Message d'erreur de la recherche
								</div>
								{error}
							</div>
						)}

						{hasSearched && (
							<h1 className="bons-plans-jeunes-result" id="bons-plans-jeunes-results">
								{hasResults ?
									`${posts.length} résultat${posts.length > 1 ? 's' : ''} pour votre recherche ${searchQuery.length > 0 ? `«${searchQuery}»` : ''}` :
									`Pas de résultat pour votre recherche ${searchQuery.length > 0 ? `«${searchQuery}»` : ''}`
								}
							</h1>
						)}
						
						{this.state.bonsPlansJeunesResetShow && (
							<BonsPlansJeunesFilterReset 
								BonsPlansJeunesOnReset={this.bonsPlansJeunesOnReset} 
								BonsPlansJeunesResetShow={this.state.bonsPlansJeunesResetShow} 
							/>
						)}
						
						{isLoading && (
							<div 
								className="loading-indicator" 
								role="status" 
								aria-live="polite"
								aria-describedby="bons-plans-jeunes-loading-description"
							>
								<div id="bons-plans-jeunes-loading-description" className="visually-hidden">
									Indicateur de chargement des résultats de recherche
								</div>
								Chargement des résultats...
							</div>
						)}
						
						{!isLoading && hasSearched && (
							<section 
								aria-label="Résultats de recherche"
								aria-describedby="bons-plans-jeunes-results"
							>
								<ul 
									id="bons-plans-jeunes-list" 
									className="bons-plans-jeunes-list list-unstyled"
									role="list"
									aria-label={`Liste des bons plans jeunes - ${hasResults ? posts.length + ' résultat(s)' : 'Aucun résultat'}`}
								>
									{hasResults && posts.map((post, index) => {
										// Validation des données du post
										if (!post || !post.attributes) {
											return (
												<li 
													className="bons-plans-jeunes-list-item-error" 
													key={`error-${index}`}
													role="listitem"
													aria-label="Élément de bon plan invalide"
												>
													<div className="visually-hidden">
														Élément de bon plan non disponible ou corrompu
													</div>
												</li>
											)
										}
										
										return (
											<>
												<BonsPlansJeunesListItem
													postIndex={index}
													postItem={post.attributes}
												/>
												{post.attributes.nom_de_la_structure && (
													<span className="visually-hidden">
														Structure : {post.attributes.nom_de_la_structure}
													</span>
												)}
											</>
										)
									})}
									{!hasResults && (
										<li 
											className="bons-plans-jeunes-no-results" 
											role="listitem"
											aria-label="Aucun résultat trouvé"
										>
											<div className="visually-hidden">
												Aucun bon plan jeune ne correspond à votre recherche
											</div>
										</li>
									)}
								</ul>
							</section>
						)}

						<div className="bons-plans-jeunes-list-footer container">
							<div className="row">
								<div className="col-sm d-flex justify-content-start">
									<p className="generic-filter-button bons-plans-jeunes-filter-button">
										<a 
											rel="noopener noreferrer" 
											className="btn btn-primary btn-lg btn-pink-3" 
											href="https://services.ville-roubaix.fr/demarches/proposition_bpj" 
											target="_blank"
											aria-label="Proposer un bon plan jeune (s'ouvre dans un nouvel onglet)"
										>
											Proposer un bon plan jeune
										</a>
									</p>
								</div>
								<div className="col-sm d-flex align-items-center">
									{totalResults > 0 && (
										<Pagination
											offset={config.bonsPlansJeunesPagination.offset}
											limit={config.bonsPlansJeunesPagination.limit}
											totals={totalResults}
											currentPage={page}
											OnClickPaginate={this.bonsPlansJeunesOnClickPaginate}
										/>
									)}
								</div>
								<div className="col-sm"></div>
							</div>
						</div>
					</main>
				</Container>
			</div>
		)
	}
}

export default connect(null, loadingActions)(BonsPlansJeunesList)